import type { FC } from 'react';
import React, { createContext, useContext, useMemo, useState } from 'react';

interface FreeCancellationDrawerActionsContextProps {
  open: () => void;
  close: () => void;
}

const FreeCancellationDrawerContext = createContext(false);
const FreeCancellationDrawerActionsContext = createContext({
  open: () => {
    /* */
  },
  close: () => {
    /* */
  },
});

const FreeCancellationDrawerProvider: FC = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const actions = useMemo(
    () => ({
      open: (): void => setOpen(true),
      close: (): void => setOpen(false),
    }),
    [setOpen]
  );

  return (
    <FreeCancellationDrawerContext.Provider value={isOpen}>
      <FreeCancellationDrawerActionsContext.Provider value={actions}>
        {children}
      </FreeCancellationDrawerActionsContext.Provider>
    </FreeCancellationDrawerContext.Provider>
  );
};

export const useIsFreeCancellationDrawerOpen = (): boolean =>
  useContext(FreeCancellationDrawerContext);
export const useFreeCancellationDrawerActions =
  (): FreeCancellationDrawerActionsContextProps =>
    useContext(FreeCancellationDrawerActionsContext);
export default FreeCancellationDrawerProvider;
